import { useEffect } from 'react';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import { CatalogSearchResults } from '../features/search';
import useWootricSurvey from '../hooks/useWootricSurvey';
// @ts-expect-error Could not find a declaration file for module
import WeekOfRestBanner from '../components/Banners/WeekOfRestBanner';
import { RESULTS_URL_FRAGMENT } from '../constants/Navigation';
import { jsx as _jsx } from "react/jsx-runtime";
const Catalog = () => {
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.TRACKS
    });
  }, []);
  useWootricSurvey('CES');
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(CatalogSearchResults, {
    banners: /*#__PURE__*/_jsx(WeekOfRestBanner, {}),
    pageUrlFragment: RESULTS_URL_FRAGMENT
  });
};
export default Catalog;